var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3157 16.1122H2.87695L2.88941 3.86517H19.722V5.67869M14.8299 18.1689H7.63154M2.88941 20.2255H16.2346M21.6285 20.2255H20.466M20.466 20.2255L21.4425 14.5454H20.4195M20.466 20.2255H16.2346M16.2346 20.2255L15.3976 14.5454H16.3741M16.3741 14.5454C15.8471 13.8492 14.4141 12.086 15.3441 9.42779C15.8583 9.42779 16.6535 9.47851 17.1181 10.1309M16.3741 14.5454H17.4901M17.9086 11.6024C17.7649 11.1355 17.3696 10.4841 17.1181 10.1309M17.9086 11.6024C17.3506 12.5517 17.3971 13.9757 17.4901 14.5454M17.9086 11.6024C18.1597 11.1752 18.9432 9.94197 19.9715 9.42779M17.1181 10.1309C16.7926 9.46633 17.2111 7.52017 18.4201 6.66575C18.7921 6.90309 20.4857 8.39942 19.9715 9.42779M19.9715 9.42779L21.6285 8.80454C22.5424 10.4562 21.6285 13.2806 20.4195 14.5454M17.4901 14.5454H20.4195",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOffice);
export default __webpack_public_path__ + "static/media/home_office.9c1704dd3fa52cd20e7270c77ea4e5e1.svg";
export { ForwardRef as ReactComponent };